export default {
	namespaced: true,
	state: {
		userInfo: {
			user: '',
			token: '',
			auth:{},
			authMenu:[]
		}
	},
	mutations: {
		//设置用户信息
		setUser(state, payload) {
			state.userInfo = payload;
		},
		//清空
		clearUser(state) {
			state.userInfo = {
				user: '',
				token: '',
				auth:{},
				authMenu:[]
			}
		}
	},
	actions: {
		logout({
			commit
		}) {
			resetRouter();
			commit('menuModule/clearasyncMenu');
			// ...其他清理
		}
	},
	getters: {

	}

}